import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "image-counter"
};
import { ref, watchEffect, onMounted, onUnmounted } from '../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal, getPlatform } from '@tencentcloud/universal-api';
import Icon from '../../common/Icon.vue';
import iconClose from '../../../assets/icon/icon-close.svg';
import iconArrowLeft from '../../../assets/icon/icon-arrow-left.svg';
import iconZoomIn from '../../../assets/icon/zoom-in.svg';
import iconZoomOut from '../../../assets/icon/zoom-out.svg';
import iconRotateLeft from '../../../assets/icon/rotate-left.svg';
import iconRotateRight from '../../../assets/icon/rotate-right.svg';
import iconDownload from '../../../assets/icon/download.svg';
import ImageItem from './image-item.vue';
import { Toast, TOAST_TYPE } from '../../common/Toast/index';
import { isPC, isMobile, isUniFrameWork } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    imageList: {
      default: () => []
    },
    currentImage: {}
  },
  emits: ['close'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var imageFormatMap = new Map([[1, 'jpg'], [2, 'gif'], [3, 'png'], [4, 'bmp']]);
    var emit = __emit;
    var zoom = ref(1);
    var rotate = ref(0);
    var minZoom = ref(0.1);
    var currentImageIndex = ref(0);
    var image = ref();
    var ulRef = ref();
    // touch
    var startX = 0;
    var touchStore = {};
    var moveFlag = false;
    var twoTouchesFlag = false;
    var timer = null;
    watchEffect(() => {
      currentImageIndex.value = props.imageList.findIndex(message => {
        var _props$currentImage;
        return message.ID === (props === null || props === void 0 || (_props$currentImage = props.currentImage) === null || _props$currentImage === void 0 ? void 0 : _props$currentImage.ID);
      });
    });
    var isNumber = value => {
      return typeof value === 'number' && isFinite(value);
    };
    var handleTouchStart = e => {
      e.preventDefault();
      moveInit(e);
      twoTouchesInit(e);
    };
    var handleTouchMove = e => {
      e.preventDefault();
      moveFlag = true;
      if (e.touches && e.touches.length === 2) {
        twoTouchesFlag = true;
        handleTwoTouches(e);
      }
    };
    var handleTouchEnd = e => {
      var _e$changedTouches$;
      e.preventDefault();
      e.stopPropagation();
      var moveEndX = 0;
      var X = 0;
      if (twoTouchesFlag) {
        if (!timer) {
          twoTouchesFlag = false;
          delete touchStore.pageX2;
          delete touchStore.pageY2;
          timer = setTimeout(() => {
            timer = null;
          }, 200);
        }
        return;
      }
      // H5 touch move to left to go to prev image
      // H5 touch move to right to go to next image
      if (timer === null) {
        switch (moveFlag) {
          // touch event
          case true:
            moveEndX = e === null || e === void 0 || (_e$changedTouches$ = e.changedTouches[0]) === null || _e$changedTouches$ === void 0 ? void 0 : _e$changedTouches$.pageX;
            X = moveEndX - startX;
            if (X > 100) {
              goPrev();
            } else if (X < -100) {
              goNext();
            }
            break;
          // click event
          case false:
            close();
            break;
        }
        timer = setTimeout(() => {
          timer = null;
        }, 200);
      }
    };
    var handleTouchCancel = () => {
      twoTouchesFlag = false;
      delete touchStore.pageX1;
      delete touchStore.pageY1;
    };
    var handleWheel = e => {
      e.preventDefault();
      if (Math.abs(e.deltaX) !== 0 && Math.abs(e.deltaY) !== 0) return;
      var scale = zoom.value;
      scale += e.deltaY * (e.ctrlKey ? -0.01 : 0.002);
      scale = Math.min(Math.max(0.125, scale), 4);
      zoom.value = scale;
    };
    var moveInit = e => {
      var _e$changedTouches$2;
      startX = e === null || e === void 0 || (_e$changedTouches$2 = e.changedTouches[0]) === null || _e$changedTouches$2 === void 0 ? void 0 : _e$changedTouches$2.pageX;
      moveFlag = false;
    };
    var twoTouchesInit = e => {
      var touch1 = e === null || e === void 0 ? void 0 : e.touches[0];
      var touch2 = e === null || e === void 0 ? void 0 : e.touches[1];
      touchStore.pageX1 = touch1 === null || touch1 === void 0 ? void 0 : touch1.pageX;
      touchStore.pageY1 = touch1 === null || touch1 === void 0 ? void 0 : touch1.pageY;
      if (touch2) {
        touchStore.pageX2 = touch2 === null || touch2 === void 0 ? void 0 : touch2.pageX;
        touchStore.pageY2 = touch2 === null || touch2 === void 0 ? void 0 : touch2.pageY;
      }
    };
    var handleTwoTouches = e => {
      var touch1 = e === null || e === void 0 ? void 0 : e.touches[0];
      var touch2 = e === null || e === void 0 ? void 0 : e.touches[1];
      if (touch2) {
        if (!isNumber(touchStore.pageX2)) {
          touchStore.pageX2 = touch2.pageX;
        }
        if (!isNumber(touchStore.pageY2)) {
          touchStore.pageY2 = touch2.pageY;
        }
      }
      var getDistance = (startX, startY, stopX, stopY) => {
        return Math.hypot(stopX - startX, stopY - startY);
      };
      if (!isNumber(touchStore.pageX1) || !isNumber(touchStore.pageY1) || !isNumber(touchStore.pageX2) || !isNumber(touchStore.pageY2)) {
        return;
      }
      var touchZoom = getDistance(touch1.pageX, touch1.pageY, touch2.pageX, touch2.pageY) / getDistance(touchStore.pageX1, touchStore.pageY1, touchStore.pageX2, touchStore.pageY2);
      zoom.value = Math.min(Math.max(0.5, zoom.value * touchZoom), 4);
    };
    onMounted(() => {
      var _document, _document2;
      // web: close on esc keydown
      ((_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener) && ((_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.addEventListener('keydown', handleEsc));
    });
    var handleEsc = e => {
      e.preventDefault();
      if ((e === null || e === void 0 ? void 0 : e.keyCode) === 27) {
        close();
      }
    };
    var zoomIn = () => {
      zoom.value += 0.1;
    };
    var zoomOut = () => {
      zoom.value = zoom.value - 0.1 > minZoom.value ? zoom.value - 0.1 : minZoom.value;
    };
    var close = () => {
      emit('close');
    };
    var rotateLeft = () => {
      rotate.value -= 90;
    };
    var rotateRight = () => {
      rotate.value += 90;
    };
    var goNext = () => {
      currentImageIndex.value < props.imageList.length - 1 && currentImageIndex.value++;
      initStyle();
    };
    var goPrev = () => {
      currentImageIndex.value > 0 && currentImageIndex.value--;
      initStyle();
    };
    var initStyle = () => {
      zoom.value = 1;
      rotate.value = 0;
    };
    var getImageUrl = message => {
      if (isPC) {
        var _message$payload;
        return message === null || message === void 0 || (_message$payload = message.payload) === null || _message$payload === void 0 || (_message$payload = _message$payload.imageInfoArray[0]) === null || _message$payload === void 0 ? void 0 : _message$payload.url;
      } else {
        var _message$payload2;
        return message === null || message === void 0 || (_message$payload2 = message.payload) === null || _message$payload2 === void 0 || (_message$payload2 = _message$payload2.imageInfoArray[2]) === null || _message$payload2 === void 0 ? void 0 : _message$payload2.url;
      }
    };
    var save = () => {
      var _imageMessage$payload;
      var imageMessage = props.imageList[currentImageIndex.value];
      var imageSrc = imageMessage === null || imageMessage === void 0 || (_imageMessage$payload = imageMessage.payload) === null || _imageMessage$payload === void 0 || (_imageMessage$payload = _imageMessage$payload.imageInfoArray[0]) === null || _imageMessage$payload === void 0 ? void 0 : _imageMessage$payload.url;
      if (!imageSrc) {
        Toast({
          message: TUITranslateService.t('component.图片 url 不存在'),
          type: TOAST_TYPE.ERROR
        });
        return;
      }
      switch (getPlatform()) {
        case 'wechat':
          // 获取用户的当前设置，获取相册权限
          TUIGlobal.getSetting({
            success: res => {
              // 如果没有相册权限
              if (!(res !== null && res !== void 0 && res.authSetting['scope.writePhotosAlbum'])) {
                // 提前向用户发起授权请求
                TUIGlobal.authorize({
                  scope: 'scope.writePhotosAlbum',
                  success() {
                    downloadImgInUni(imageSrc);
                  },
                  fail() {
                    TUIGlobal.showModal({
                      title: '您已拒绝获取相册权限',
                      content: '是否进入权限管理，调整授权？',
                      success: res => {
                        if (res.confirm) {
                          // 调起客户端小程序设置界面，返回用户设置的操作结果。（重新让用户授权）
                          TUIGlobal.openSetting({
                            success: res => {
                              console.log(res.authSetting);
                            }
                          });
                        } else if (res.cancel) {
                          return Toast({
                            message: TUITranslateService.t('component.已取消'),
                            type: TOAST_TYPE.ERROR
                          });
                        }
                      }
                    });
                  }
                });
              } else {
                // 如果已有相册权限，直接进行保存到相册
                downloadImgInUni(imageSrc);
              }
            },
            fail: () => {
              Toast({
                message: TUITranslateService.t('component.获取权限失败'),
                type: TOAST_TYPE.ERROR
              });
            }
          });
          break;
        case 'app':
          downloadImgInUni(imageSrc);
          break;
        default:
          downloadImgInWeb(imageSrc);
          break;
      }
    };
    var downloadImgInUni = src => {
      // 下载图片文件
      TUIGlobal.showLoading({
        title: '大图提取中'
      });
      TUIGlobal.downloadFile({
        url: src,
        success: function success(res) {
          TUIGlobal.hideLoading();
          TUIGlobal.saveImageToPhotosAlbum({
            filePath: res.tempFilePath,
            success: () => {
              Toast({
                message: TUITranslateService.t('component.已保存至相册'),
                type: TOAST_TYPE.SUCCESS
              });
            }
          });
        },
        fail: function fail() {
          TUIGlobal.hideLoading();
          Toast({
            message: TUITranslateService.t('component.图片下载失败'),
            type: TOAST_TYPE.ERROR
          });
        }
      });
    };
    var downloadImgInWeb = src => {
      var _imageMessage$payload2;
      var option = {
        mode: 'cors',
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      };
      var imageMessage = props.imageList[currentImageIndex.value];
      var imageFormat = imageMessage === null || imageMessage === void 0 || (_imageMessage$payload2 = imageMessage.payload) === null || _imageMessage$payload2 === void 0 ? void 0 : _imageMessage$payload2.imageFormat;
      if (!imageFormatMap.has(imageFormat)) {
        Toast({
          message: TUITranslateService.t('component.暂不支持下载此类型图片'),
          type: TOAST_TYPE.ERROR
        });
        return;
      }
      // 浏览器支持fetch则用blob下载，避免浏览器点击a标签，跳转到新页面预览的行为
      // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
      if (window.fetch) {
        fetch(src, option).then(res => res.blob()).then(blob => {
          var a = document.createElement('a');
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = url + '.' + imageFormatMap.get(imageFormat);
          a.click();
        });
      } else {
        var a = document.createElement('a');
        a.href = src;
        a.target = '_blank';
        a.download = src + '.' + imageFormatMap.get(imageFormat);
        a.click();
      }
    };
    onUnmounted(() => {
      var _document3, _document4;
      ((_document3 = document) === null || _document3 === void 0 ? void 0 : _document3.removeEventListener) && ((_document4 = document) === null || _document4 === void 0 ? void 0 : _document4.removeEventListener('keydown', handleEsc));
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["image-previewer", [_unref(isMobile) && 'image-previewer-h5']])
      }, [_createElementVNode("div", {
        ref_key: "image",
        ref: image,
        class: "image-wrapper",
        onTouchstart: _withModifiers(handleTouchStart, ["stop"]),
        onTouchmove: _withModifiers(handleTouchMove, ["stop"]),
        onTouchend: _withModifiers(handleTouchEnd, ["stop"]),
        onTouchcancel: _withModifiers(handleTouchCancel, ["stop"]),
        onWheel: _withModifiers(handleWheel, ["stop"])
      }, [_createElementVNode("ul", {
        ref_key: "ulRef",
        ref: ulRef,
        class: "image-list",
        style: _normalizeStyle({
          width: "".concat(_ctx.imageList.length * 100, "%"),
          transform: "translateX(-".concat(_unref(currentImageIndex) * 100 / _ctx.imageList.length, "%)"),
          transition: '0.5s'
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "image-item"
        }, [_createVNode(ImageItem, {
          zoom: _unref(zoom),
          rotate: _unref(rotate),
          src: getImageUrl(item),
          messageItem: item,
          class: _normalizeClass([_unref(isUniFrameWork) ? 'image-item' : ''])
        }, null, 8, ["zoom", "rotate", "src", "messageItem", "class"])]);
      }), 128))], 4)], 544), _withDirectives(_createElementVNode("div", {
        class: "icon icon-close",
        onClick: close
      }, [_createVNode(Icon, {
        file: _unref(iconClose),
        width: "16px",
        height: "16px"
      }, null, 8, ["file"])], 512), [[_vShow, _unref(isPC)]]), _unref(isPC) && _unref(currentImageIndex) > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "image-button image-button-left",
        onClick: goPrev
      }, [_createVNode(Icon, {
        file: _unref(iconArrowLeft)
      }, null, 8, ["file"])])) : _createCommentVNode("", true), _unref(isPC) && _unref(currentImageIndex) < _ctx.imageList.length - 1 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "image-button image-button-right",
        onClick: goNext
      }, [_createVNode(Icon, {
        file: _unref(iconArrowLeft)
      }, null, 8, ["file"])])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(['actions-bar', _unref(isMobile) && 'actions-bar-h5'])
      }, [_unref(isPC) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "icon-zoom-in",
        onClick: zoomIn
      }, [_createVNode(Icon, {
        file: _unref(iconZoomIn),
        width: "27px",
        height: "27px"
      }, null, 8, ["file"])])) : _createCommentVNode("", true), _unref(isPC) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "icon-zoom-out",
        onClick: zoomOut
      }, [_createVNode(Icon, {
        file: _unref(iconZoomOut),
        width: "27px",
        height: "27px"
      }, null, 8, ["file"])])) : _createCommentVNode("", true), _unref(isPC) ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "icon-refresh-left",
        onClick: rotateLeft
      }, [_createVNode(Icon, {
        file: _unref(iconRotateLeft),
        width: "27px",
        height: "27px"
      }, null, 8, ["file"])])) : _createCommentVNode("", true), _unref(isPC) ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "icon-refresh-right",
        onClick: rotateRight
      }, [_createVNode(Icon, {
        file: _unref(iconRotateRight),
        width: "27px",
        height: "27px"
      }, null, 8, ["file"])])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(currentImageIndex) + 1) + " / " + _toDisplayString(_ctx.imageList.length), 1)], 2), _createElementVNode("div", {
        class: "save",
        onClick: _withModifiers(save, ["stop", "prevent"])
      }, [_createVNode(Icon, {
        file: _unref(iconDownload),
        width: "20px",
        height: "20px"
      }, null, 8, ["file"])])], 2);
    };
  }
});